<template>
<div :class="['micad_formElement micad_formElement_year',getType(type)]">
    <label class="micad_formElement_label">{{label}}</label>
    <div class="micad_formElement_control">
        <select class="micad_formElement_control_input">
        <option >Please choose</option>
        <option v-for="item in items" :key="item">{{item}}</option>
        </select>        
    </div>
    <div class="micad_formElement_message">{{message}}</div>
</div>
</template>

<script>
export default {
  name: 'Year',
  data() {
    return {
        label: "Quisque tristique.",
        items: ["2001", "2002", "2003", "2004", "2005", "2006"],
        message: "Quisque tristique quis leo vitae luctus."
        }
    },
    props: {
        type: String,
    },
    methods: {
        getType(type) {
            if (type !== undefined) {
                return ' micad_formElement_'+type
            }
        }
    }
};
</script>
